import React from "react";
import { PostData } from "../components/Functions/SendingData";
import PageBuilder from "../components/NewComp/PageBuilder";
import styled from "styled-components";
import { LoadingWLogo } from "../components/LoadingWLogo";
import CatDescription from "../components/HomeComp/MainView/CatDescription";
import PageTitlesFunc from "../components/Functions/PageTitlesFunc";

const Style = styled.div`
    min-height: 100vh;
    margin: auto;
    &.main-container {
        margin: 0 0 60px;
        text-align: center;
        /* font-size: 2em; */
        direction: rtl;
        overflow-x: hidden;
        
    }
`

class CategoryPageNew extends React.Component{
    constructor(props) {
        super(props);
        let newgr = props.match.params.catID;
        if(props.match.params.catID === undefined){
            newgr = '';
        }
        this.state={
            gr: newgr,
            type:'',
            loading: true,
            grcode:'',
            subgrcode:'',
            tagcode:'',
            breadData: [{
                name: 'نمایشگاه',
                link: '/'
            }],
        }
    }

    componentDidMount(){
        this.getDataGr()
    }

    getSnapshotBeforeUpdate(prevProps, prevState){
        if(prevProps.match.params.catID !== this.props.match.params.catID){
            return true;
        } else {
            return false;
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if (snapshot){
            let newgr = this.props.match.params.catID;
            if(this.props.match.params.catID === undefined){
                newgr = '';
            }
            if(prevState.gr !== newgr){
                this.setState({
                    gr: newgr,
                });
                this.getDataGr(newgr);
              
                window.scrollTo({
                    top: 0 ,
                    left: 0,
                    behavior: 'smooth'
                });
            }   
        }
    }
    getDataGr = (name = this.state.gr) => {
        let formData = new FormData();
        let userdata = this.state.userdata;
        formData.append('NAME',name);
        formData.append('SH_CODE',-1);

        if(userdata && userdata.usercode){
            formData.append('api_token', this.state.userdata.token);
            formData.append('U_CODE',userdata.usercode);
        }
        this.setState({
            response: 'pending',
            loading: true,
        });
        
        PostData(process.env.REACT_APP_API + '/api/v1/exb/goods/mix_page_filter',formData, this, this.ProccessMainGrData);
    }
    ProccessMainGrData(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success'){
            let desc=[]
            if(response.Type === 'Group'){
                if(response.Groups.G_GR_DESC !== null &&  response.Groups.G_GR_DESC !== ''){
                    desc = JSON.parse(response.Groups.G_GR_DESC)
                }
            }else if(response.Type === 'Tag'){
                if(response.Tag.G_TAG_DESC !== null && response.Tag.G_TAG_DESC !== ''){
                    desc= JSON.parse(response.Tag.G_TAG_DESC)
                }
            }else if(response.Type === 'Subgroup'){
                if(response.Subgroup.G_SUBGR_DESC !== null && response.Subgroup.G_SUBGR_DESC !== ''){
                    desc= JSON.parse(response.Subgroup.G_SUBGR_DESC)
                }
            }
            // else if(response.Type === 'Tag'){
            //     if(response.Tag.G_TAG_DESC !== null && response.Tag.G_TA_DESC !== ''){
            //         desc= JSON.parse(response.Tag.G_TAG_DESC)
            //     }else{
            //         desc='empty'
            //     }
            // }

            let title =''
            let shortdesc = ''
            let findPageTitle = desc.find((val)=>val.type === 'pagetitle')

            if(findPageTitle){
                title= findPageTitle.data
            }
            let findPageDesc = desc.find((val)=>val.type === 'pagemetadesc')
            if(findPageDesc){
                shortdesc= findPageDesc.data
            }

            

            if(response.Type === 'Group'){
                obj.setState({
                    all: response.Groups,
                    grcode: response.Groups.G_GR_CODE,
                    description: desc,
                    img:response.Groups.G_GR_IMG,
                    grname:response.Groups.G_GR_NAME,
                    sub:response.Groups.sub_groups,
                    default : response.Groups.G_GR_IS_DEFAULT,
                    ribbons: response.Groups.Data,
                    address:'categorypage',
                })
                PageTitlesFunc({
                    title :  (title!=='') ? title :'لوکسین لوکس - ' + response.Groups.G_GR_NAME, 
                    description: (shortdesc!=='') ? shortdesc :'لیست محصولات' , 
                    canonical: 'https://' + window.location.hostname + '/category/' + obj.props.match.params.catID
                })
            }else if(response.Type === 'Subgroup'){
                obj.setState({
                    all: response.Subgroup,
                    grcode: response.Subgroup.G_SUBGR_CODE,
                    img:response.Subgroup.G_GR_IMG,
                    grname:response.Subgroup.G_GR_NAME ,
                    subname:response.Subgroup.G_SUBGR_NAME,
                    default : response.Subgroup.G_SUBGR_IS_DEFAULT,
                    ribbons: response.Subgroup.Data,
                    address:'subcategorypage'
                })
                PageTitlesFunc({
                    title : (title!=='') ? title :'لوکسین لوکس - ' +  response.Subgroup.G_SUBGR_NAME, 
                    description: (shortdesc!=='') ? shortdesc :'لیست محصولات' , 
                    canonical: 'https://' + window.location.hostname + '/category/' + obj.props.match.params.catID
                })
            }
            else{
                obj.setState({
                    all: response.Tag,
                    grcode: response.Tag.G_TAG_CODE,
                    img:response.Tag.G_GR_IMG,
                    grname:response.Tag.G_TAG_NAME ,
                    default : response.G_TAG_IS_DEFAULT,
                    ribbons: response.Tag.Data,
                    address:'tagpage'
                })
                PageTitlesFunc({
                    title : (title!=='') ? title :'لوکسین لوکس - ' +  response.Tag.G_TAG_NAME, 
                    description: (shortdesc!=='') ? shortdesc :'لیست محصولات' , 
                    canonical: 'https://' + window.location.hostname + '/category/' + obj.props.match.params.catID
                })
            }
            obj.setState({
                type : response.Type,
                loading: false,
            })
            obj.makeBreadCrombData()
        } else if (response.status === 'error') {
            obj.setState({
                loading: false,
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                loading: false,
            });
        }
    }
    makeBreadCrombData = ()=> {
        let mainName = 'خانه';
        let startLink = '/';
        let newbreadData = [
            {
                name: mainName,
                link: startLink
            },
        ]
        if(this.state.address === 'categorypage'){
            newbreadData.push(
                {
                    name: this.state.all.G_GR_NAME,
                    link: '/category/' + this.state.all.G_GR_EN_NAME+'/'
                }
            )
        }else if(this.state.address === 'tagpage'){
            newbreadData.push(
                {
                    name: this.state.all.G_GR_NAME,
                    link: '/category/' + this.state.all.G_GR_EN_NAME+'/'
                }
            )
            newbreadData.push(
                {
                    name: this.state.all.G_TAG_NAME,
                    link: '/category/' + this.state.all.G_TAG_EN_NAME+'/',
                    // diactive: false
                }
            )
        }else if(this.state.address === 'subcategorypage'){
            newbreadData.push(
                {
                    name: this.state.all.G_GR_NAME,
                    link: '/category/' + this.state.all.G_GR_EN_NAME+'/'
                }
            )
            newbreadData.push(
                {
                    name: this.state.all.G_TAG_NAME,
                    link: '/category/' + this.state.all.G_TAG_EN_NAME+'/',
                    // diactive: false
                }
            )
            newbreadData.push(
                {
                    name: this.state.all.G_SUBGR_NAME,
                    link: '/category/' + this.state.all.G_SUBGR_EN_NAME+'/'
                }
            )
        }else if(this.state.address === 'tagpage'){
            newbreadData.push(
                {
                    name: this.state.all.G_GR_NAME,
                    link: '/category/' + this.state.all.G_GR_EN_NAME+'/'
                }
            )
            newbreadData.push(
                {
                    name: this.state.all.G_TAG_NAME,
                    link: '/category/' + this.state.all.G_TAG_EN_NAME+'/',
                    diactive: false
                }
            )
        }

        this.setState({
            breadData: newbreadData,
        })
    }
   
    createName=()=>{
        let name= this.state.address
        switch(this.state.address){
            case 'categorypage':
                if(this.state.default === 1){
                    name ='categorypage_'+this.state.gr
                }
                return {Viname: name, params:{G_GR_CODE :  this.state.grcode}};
            case 'tagpage':
                if(this.state.default === 1){
                    name ='tagpage_'+this.state.gr
                }
                return {Viname: name ,params:{G_TAG_CODE :  this.state.grcode}};
            case 'subcategorypage':
                if(this.state.default === 1){
                    name ='subcategorypage_'+this.state.gr
                }
                return {Viname:name ,params:{G_SUBGR_CODE :  this.state.grcode}};
            default:
                return {Viname: name ,params:{G_GR_CODE :  this.state.grcode}};
        }
    }
   
    render(){
        if(!this.state.loading){
            let data= this.createName()
            return(
                <Style className="main-container">
                    <PageBuilder 
                        {...this.props} 
                        name={data.Viname}
                        params={data.params}
                        ribbons={this.state.ribbons}
                        filters={{
                            EN_NAME:this.state.gr,
                            CODE: this.state.grcode,
                            IMG: this.state.img,
                            NAME: this.state.grname,
                            SUB_GROUPS:this.state.sub,
                            breadData: this.state.breadData,
                        }}
                    />
                    
                    {data.Viname ? <CatDescription name={data.Viname} groupData={this.state.all} /> :'' }
                </Style>
            ) 
        }else{
            return <Style> <LoadingWLogo/> </Style>
        }
    }
}
export default CategoryPageNew;

